<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/apppointsnewodetoJoyinfo/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
    addShowPower="/apppointsnewodetoJoyinfo/select"
      :show="true"
           @openAddDialog="openAddDialog"
      downloadPower="/apppointsnewodetoJoyinfo/PeopleExport"
      :showDownloadPower="false"
      @down="down"
      showDownloadPowerType="warning"
        totaltext="/transactionmanage/heji"
   :totalShow="true"
      @totalLookDialog="totalLookDialog()"
       totalName="合计"
        
    >
     
      <el-form-item label="商户号">
        <el-input v-model="formModel.machinesId" placeholder="请输入"></el-input>
      </el-form-item>
 <el-form-item label="日期">
        <el-date-picker
          v-model="formModel.payTime"
          type="daterange"
          range-separator="至"
          :clearable="true"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="machinesId"
        label="商户号"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="date"
        label="日期"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="money"
        label="总金额"
        :formatter="formatterTableNumber"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="examineMoney"
        label="刷卡金额"
        :formatter="formatterTableNumber"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
   
    
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="'添加'"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
    
      class="note"
      labelWidth="120px"
      dialogWidth="439px"
    >
      <el-form-item label="商户号" prop="machinesId">
        <el-input
          type="text"
          maxlength="20"
          v-model="dialogModel.machinesId"
          placeholder="请输入"
          style="width: 280px"
        ></el-input>
      </el-form-item>
      
        <el-form-item label="总金额" prop="money">
        <el-input
          type="text"
          maxlength="20"
          v-model="dialogModel.money"
          placeholder="请输入"
          style="width: 280px"
        ></el-input>
      </el-form-item>
        <el-form-item label="刷卡金额" prop="examineMoney">
        <el-input
          type="text"
          maxlength="20"
          v-model="dialogModel.examineMoney"
          placeholder="请输入"
          style="width: 280px"
        ></el-input>
      </el-form-item>
        <el-form-item label="活动时间" prop='date'>
        <el-date-picker
          v-model="dialogModel.date"
          type="date"
          value-format="yyyy-MM-dd"
         
          placeholder="选择日期"
       
        >
        </el-date-picker>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import TimeRange from "service/constant/TimeRange";
import FormDialog from "../../dialog/FormDialog";

import TransactionService from "service/TransactionService";
import StatisticsService from "service/StatisticsService";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "apppointsnewodetoJoyinfo",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
  },
  data() {
    return {
      formModel: {
        machinesId: '',
        payTime: '',
      },
      tableData: [],
      status: [
        {
          dictKey: "",
          dictValue: "全部",
        },
        {
          dictKey: "0",
          dictValue: "未启动",
        },
        {
          dictKey: "1",
          dictValue: "进行中",
        },
        {
          dictKey: "2",
          dictValue: "已结束",
        },
      ],
      itemId: "",
      dialogModel: {
        machinesId: "",
        money: '',
        examineMoney: '',
      },
      dialogRules: {
        machinesId: [
          {
            required: true,
            message: "请输入",
          },
        ],
        money: [
          {
            required: true,
            message: "请输入",
          },
        ],
        examineMoney: [
          {
            required: true,
            message: "请输入",
          },
        ],
         date: [
          {
            required: true,
            message: "请选择",
          },
        ],
      },
      submitService: TransactionService.tradeList,
      params: {},
      page: {},
      isPage: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
  },
  computed: {
    submitData() {
     if (this.formModel.payTime == null || this.formModel.payTime == "") {
        this.formModel.payTime = [];
      }
      const params = {
       
        machinesId:this.formModel.machinesId,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
     if (this.formModel.payTime.length) {
        params.startDate = this.formModel.payTime[0];
        params.endDate = this.formModel.payTime[1];
      }
      return params;
    },
    dialogData() {
      const params = {
        machinesId: this.dialogModel.machinesId,
        date: this.dialogModel.date,
        money: this.dialogModel.money,
        examineMoney: this.dialogModel.examineMoney,
      };
      if (this.itemId) {
        params.id = this.itemId;
      }
      return params;
    },
    dialogService() {
      return TransactionService.addTradeList;
    },
    ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
  },
  methods: {
    load() {
      this.formModel = {
        status: "",
        time: TimeRange.monthRange,
        payTime: "",
      };
      this.page = this.$refs.commonTable.page;
      this.getList();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    handleDelete(item) {
      this.showConfirm("是否执行？")
        .then(() => {
          this.doDelete(item.id);
        })
        .catch(() => {});
    },
    doDelete(id) {
      this.doLoad(
        TransactionService.apppointsnewodetoJoyinfoUp,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    openAddDialog(item, flag) {
      this.itemId = item ? item.id : "";
      if (this.itemId) {
        this.isFlag = true;
        this.dialogModel = JSON.parse(JSON.stringify(item));
      }
      this.$refs.formDialog.open();
    },

    dialogClose() {
      this.dialogModel = {
        sn: "",
      };
      this.itemId = "";
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    look(row) {
      this.$router.push({
        name: "apppointsnewodetoJoyinfolook",
        params: {
          item: JSON.stringify(row),
        },
      });
    },
    formatterTablestatus(row, column, cellValue, index) {
      let value = "--";
      this.status.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value;
    },
    down() {
      this.limitExport(this.page.total)
        ? StatisticsService.exportExcel(
            this.submitData,
            "exportHlfInfo",
            "8885",
            "/hlf/t-hlf-info-dtl/"
          )
        : "";
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/AppManager/AppBussiness.vue